export interface IError {
  code: string;
  message: string;
}

export interface IErrorComponentData {
  icon: EERROR_ICON;
  title: string;
  description: string;
  buttons: IErrorButton[];
}

export interface IErrorButton {
  buttonText: string;
  buttonEvent: EERROR_BUTTON_EVENT;
}

export enum EERROR_TYPE {
  SNACKBAR = 'snackbar',
  MODAL = 'modal',
  COMPONENT = 'component',
}

export enum EERROR_ICON {
  WARNING = '/assets/icons/error-warning.svg',
  TIME_OUT = '/assets/icons/clock-orange.svg',
  CAUTION = '/assets/icons/caution.svg',
  ERROR = '/assets/icons/check_error.svg',
}

export enum EERROR_BUTTON_EVENT {
  RETURN_TO_ECCOMERCE = 'return-to-eccomerce',
  TRY_AGAIN = 'try-again',
  CONTINUE = 'continue',
  SETUP_PASSWORD = 'setup-password',
  GO_TO_MY_PROFILE = 'go-to-my-profile',
  GO_TO_LANDING = 'go-to-landing',
}

export enum EERROR_PAGE_TYPES {
  ERROR_01 = 'error-tecnico-01',
  ERROR_02 = 'error-en-confirmación-1',
  ERROR_03 = 'error-en-pago-1',
  ERROR_04 = 'error-en-pago-2',
  ERROR_05 = 'salida-del-proceso',
  ERROR_06 = 'error-en-pago-3',
  ERROR_07 = 'error-al-validar-datos-1',
  ERROR_08 = 'error-al-validar-datos-2',
  ERROR_09 = 'error-tarjeta-vencida', //Expired card error in first purchase
  ERROR_10 = 'error-rechazo-01',
  ERROR_11 = 'error-rechazo-02',
  ERROR_12 = 'error-en-pago-4',
  ERROR_13 = 'error-en-cvv',
  ERROR_14 = 'error-en-tarjeta-1',
  ERROR_15 = 'error-en-tarjeta-2',
  ERROR_16 = 'error-en-tarjeta-3',
  ERROR_17 = 'error-en-tarjeta-4', //Expired card error in second purchase
  ERROR_18 = 'error-en-identificacion',
  ERROR_19 = 'error-limite-compra',
  ERROR_20 = 'error-token-id',
  ERROR_21 = 'error-tarjeta-5',
}

export interface ICardError {
  http_code: number;
  error_code: string;
  category: string;
  description: string;
  request_id: string;
}
